import { ComparisonEffects } from './comparison.effects';

export const effects: any[] = [ComparisonEffects];
